import React from "react";
import { useParams } from "react-router";
import { Col, Container, Row } from "reactstrap";
import CollapsibleCard from "src/components/CollapsibleCard/CollapsibleCard";
import CopyToClipboard from "src/components/CopyToClipboard/CopyToClipboard";
import { IconName } from "src/components/Icon/Icon";
import * as S from "src/constants/StringConstants";

interface RouteParams {
  id: string;
}

const AffiliateQuotesWidget: React.FC = () => {
  const { id: affiliateID } = useParams<RouteParams>();
  const affiliateUrl = affiliateID ? `${S.AQW_AFFILIATE_URL}${affiliateID}` : "";

  return (
    <CollapsibleCard
      title={S.PD_BROKER_QUOTES_LINKS_HEADER}
      iconName={IconName.BrokerBuilderQuotes}
      defaultOpen={true}>
      <Container>
        {affiliateID && (
          <>
            <Row>
              <Col className="link-row">
                <a className="linkItem" href={affiliateUrl} target="_blank">
                  {S.AQW_AFFILIATE}
                </a>
                <CopyToClipboard textToCopy={affiliateUrl} />
              </Col>
            </Row>

            <Row className="card-separator" />
          </>
        )}
      </Container>
    </CollapsibleCard>
  )
}

export default AffiliateQuotesWidget;